import * as React from "react";

import SvgAssetsEmptyState from "@svg/empty-assets";

export const EmptyState: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex w-full flex-1 flex-col">
      <div className="bg-sheet border-0.5 border-border flex h-full flex-col items-center justify-center gap-3 rounded-sm border-dashed p-5">
        <SvgAssetsEmptyState />
        <div className="text-muted text-center text-xs">{children}</div>
      </div>
    </div>
  );
};
